/**
 * This file is for the configuration of axios which will be used in this project to make api requests
 */

import axios from 'axios'

const http = axios.create({
    baseURL: process.env.VUE_APP_API_URL + '/guest_api/v1',
    timeout: 90000,
})

http.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers.Authorization = `${token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default http
